import React, { useContext, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Image from '../common/image';
import Icon3 from "../../assest/images/Icon3.png";
import eye from "../../assest/images/eye.png";
import { ToastContainer, toast } from 'react-toastify';
import config from '../../envconfig';
import axios from "axios"
import { UserContext } from '../common/UserContext';
import { MdUpload, MdDownload } from "react-icons/md";
import { TiDelete } from "react-icons/ti";

const CCList = () => {
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, UM_DomainUser } = useContext(UserContext);
    const [userData, setUserdata] = useState([]);
    const [message, setMessage] = useState('');
    const [searchTerm, setSearchTerm] = useState(''); // Single search term for company name
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const navigate = useNavigate();
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [companyToRemove, setCompanyToRemove] = useState(null);

    // File input ref for direct upload
    const fileInputRefs = React.useRef({});
    const toastRef = useRef(null);
    const showToast = (type, message, options = {}) => {
        if (toastRef.current && toast.isActive(toastRef.current)) {
            toast.update(toastRef.current, {
                render: message,
                type,
                autoClose: 3000,
                ...options,
            });
        } else {
            toastRef.current = toast[type](message, {
                autoClose: 3000,
                ...options,
            });
        }
    };
    // const handleLogoDownloadClick = async (company) => {
    //     if (!company.CC_CompanyLogo) {
    //         showToast('error', "No logo available to download");
    //         return;
    //     }

    //     try {
    //         const response = await axios.get(
    //             `${config.API_URL}/downloadcompanylogo/${company.CC_ID}`,
    //             {
    //                 params: { companyId: company.CC_CM_ID },
    //                 responseType: "blob"
    //             }
    //         );

    //         /* Create downloadable file */
    //         const blob = new Blob([response.data]);
    //         const url = window.URL.createObjectURL(blob);

    //         const link = document.createElement("a");
    //         link.href = url;
    //         link.download = company.CC_CompanyLogo;
    //         document.body.appendChild(link);
    //         link.click();

    //         link.remove();
    //         window.URL.revokeObjectURL(url);

    //         showToast('success', `Logo downloaded successfully for Company : ${company.CM_CompanyName}.`);

    //     } catch (error) {
    //         console.error(error);
    //         showToast('error', "Failed to download logo");
    //     }
    // };

    // Function to handle direct file selection

    const handleLogoDownloadClick = async (company) => {
        if (!company.CC_CompanyLogo) {
            showToast('error', "No logo available to download");
            return;
        }

        try {
            const response = await axios.get(
                `${config.API_URL}/downloadcompanylogo/${company.CC_ID}`,
                {
                    params: { companyId: company.CC_CM_ID },
                    responseType: "blob"
                }
            );

            /* Get logo + company name from headers */
            // const logoName = response.headers['x-logo-name'];
            // const companyName = response.headers['x-company-name'];
            const logoName = company.CC_CompanyLogo;
            const companyName = company.CM_CompanyName;
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = logoName;
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);

            showToast(
                'success',
                `Logo : ${logoName} downloaded successfully for Company : ${companyName}.`
            );

        } catch (error) {
            console.error(error);
            showToast('error', "Failed to download logo");
        }
    };
    const handleDirectLogoUploadClick = (company) => {
        // Create a unique ref for each company if it doesn't exist
        if (!fileInputRefs.current[company.CC_ID]) {
            fileInputRefs.current[company.CC_ID] = React.createRef();
        }

        // Trigger file input click
        if (fileInputRefs.current[company.CC_ID]) {
            fileInputRefs.current[company.CC_ID].click();
        }
    };

    // Function to handle file selection and upload
    const handleFileSelected = async (event, company) => {
        const file = event.target.files[0];
        if (!file) return;

        // Validate file type
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (!validTypes.includes(file.type) && !['jpg', 'jpeg', 'png'].includes(fileExtension)) {
            showToast('error', 'Only JPG, JPEG and PNG images are allowed.');
            return;
        }

        // Check file size (max 1MB)
        if (file.size > 1 * 1024 * 1024) {
            showToast('error', 'File size should be less than 1MB.');
            return;
        }

        // Get company ID
        let companyId = company.CC_CM_ID || company.cm_id || UM_CompanyID;
        let ccId = company.CC_ID || company.cc_id;

        // Show loading toast
        const toastId = toast.loading(`Uploading logo for ${company.CM_CompanyName}...`);

        try {
            const formData = new FormData();
            formData.append('logo', file);
            formData.append('companyId', companyId);

            const response = await axios.put(
                `${config.API_URL}/updatecompanylogo/${ccId}`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }
            );

            if (response.data.success) {
                toast.update(toastId, {
                    render: `Logo : ${file.name} uploaded successfully for Company : ${company.CM_CompanyName}.`,
                    type: 'success',
                    isLoading: false,
                    autoClose: 3000
                });

                // Refresh data
                const reqData = await axios.get(`${config.API_URL}/getcompanyconfiguration`);
                setUserdata(reqData.data.data.getcompanyconfigurationres);
            } else {
                toast.update(toastId, {
                    render: response.data.message || 'Failed to upload logo',
                    type: 'error',
                    isLoading: false,
                    autoClose: 3000
                });
            }
        } catch (error) {
            console.error('Upload error:', error);
            toast.update(toastId, {
                render: error.response?.data?.message || 'Error uploading logo',
                type: 'error',
                isLoading: false,
                autoClose: 3000
            });
        }

        // Reset file input
        event.target.value = '';
    };

    useEffect(() => {
        sessionStorage.removeItem("CC_ID")
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DomainUser', UM_DomainUser);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('selectedScpId', selectedScpId);
    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId, UM_DomainUser]);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    useEffect(() => {
        const getUserdata = async () => {
            try {
                const reqData = await axios.get(`${config.API_URL}/getcompanyconfiguration`);
                console.log(reqData.data.data)
                if (reqData.data.success) {
                    const resData = reqData.data.data.getcompanyconfigurationres;
                    setUserdata(resData);
                    console.log("data---", resData);
                } else {
                    console.error('Error fetching the company list');
                }
            } catch (error) {
                setMessage('Please check Data');
            }
        };
        getUserdata();
    }, []);

    // Filter data based on company name search
    const filteredListData = userData.filter(item => {
        if (!searchTerm) return true;

        const companyName = item.CM_CompanyName || '';
        return companyName.toLowerCase().includes(searchTerm.toLowerCase());
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredListData.slice(indexOfFirstItem, indexOfLastItem);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleLogoRemoveClick = (company) => {
        if (!company.CC_CompanyLogo) return;

        setCompanyToRemove(company);
        setShowConfirmModal(true);
    };

    // Function to confirm logo removal   
    const confirmLogoRemove = async () => {
        if (!companyToRemove) return;

        try {
            const response = await axios.delete(
                `${config.API_URL}/deletecompanylogo/${companyToRemove.CC_ID}`,
                {
                    data: {
                        companyId: companyToRemove.CC_CM_ID
                    }
                }
            );

            if (response.data.success) {
                const removedLogoName = response.data.logoName;
                // showToast('success',"Logo removed successfully for Company : " + companyToRemove.CM_CompanyName + ".");
                showToast(
                    'success',
                    `Logo : ${removedLogoName} removed successfully for Company : ${companyToRemove.CM_CompanyName}.`
                );
                const reqData = await axios.get(`${config.API_URL}/getcompanyconfiguration`);
                setUserdata(reqData.data.data.getcompanyconfigurationres);
            } else {
                showToast('error', response.data.message || "Failed to remove logo");
            }
        } catch (error) {
            console.error(error);
            showToast('error', "Error removing logo");
        } finally {
            setShowConfirmModal(false);
            setCompanyToRemove(null);
        }
    };

    return (
        <React.Fragment>
            <ToastContainer style={{
                marginTop: '73px',
                fontSize: '14px',
                width: '40%',
            }} />

            <div className='main_container'>
                <h4 className='formHeading'>
                    Company Configuration
                </h4>
                <div className="filter-container">
                    {/* Replace dropdown with disabled input field */}
                    <input
                        type="text"
                        className='search-input disabled-input col-md-6'
                        value="Company Name"
                        disabled
                        readOnly
                        placeholder="Company Name"
                    />
                    <input
                        type="text"
                        className='search-input'
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Search"
                    />
                </div>

                <div className="ptable-wrapper">
                    <table className="ptableClass">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Company Name</th>
                                <th>Image</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        {filteredListData.length === 0 ? (
                            <tbody>
                                <tr>
                                    <td colSpan="4">No Records Found</td>
                                </tr>
                            </tbody>
                        ) : (
                            <tbody>
                                {currentItems.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                        <td>{item.CM_CompanyName}</td>
                                        <td>
                                            {/* Hidden file input for direct upload */}
                                            <input
                                                type="file"
                                                ref={el => fileInputRefs.current[item.CC_ID] = el}
                                                style={{ display: 'none' }}
                                                accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
                                                onChange={(e) => handleFileSelected(e, item)}
                                            />

                                            {item.CM_Status !== 3 && (
                                                <button
                                                    title="Upload"
                                                    onClick={() => handleDirectLogoUploadClick(item)}
                                                    style={styles.uploadButton}
                                                >
                                                    <MdUpload className='view ms-1' />
                                                </button>
                                            )}
                                            {item.CM_Status !== 3 && (
                                                <button
                                                    title="Download"
                                                    onClick={() => handleLogoDownloadClick(item)}
                                                    style={{
                                                        ...styles.uploadButton,
                                                        opacity: item.CC_CompanyLogo ? 1 : 0.3,
                                                        // cursor: item.CC_CompanyLogo ? "pointer" : "not-allowed"
                                                    }}
                                                    disabled={!item.CC_CompanyLogo}
                                                >
                                                    <MdDownload className='view ms-1' />
                                                </button>

                                            )}
                                            {item.CM_Status !== 3 && (
                                                <button
                                                    title="Remove"
                                                    onClick={() => item.CC_CompanyLogo ? handleLogoRemoveClick(item) : null}
                                                    style={{
                                                        ...styles.uploadButton,
                                                        opacity: item.CC_CompanyLogo ? 1 : 0.3,
                                                        // cursor: item.CC_CompanyLogo ? "pointer" : "not-allowed"
                                                    }}
                                                    disabled={!item.CC_CompanyLogo}
                                                >
                                                    <TiDelete className='view ms-1' />
                                                </button>
                                            )}
                                        </td>
                                        <td>
                                            {item.CM_Status !== 3 && (
                                                <Link
                                                    // to={`/dashboard/companyconfig`} 
                                                    to={`/dashboard/companyconfig/${item.CC_ID}`}
                                                    state={{
                                                        userid: JSON.stringify(item.UM_UserId),
                                                        isEditMode: true,
                                                    }}
                                                    title="Edit"
                                                // onClick={() => {
                                                //     sessionStorage.setItem("CC_ID", JSON.stringify(item.CC_ID));
                                                //     navigate(`/dashboard/companyconfig`);
                                                // }}
                                                >

                                                    <Image src={Icon3} alt="pencil" className="editicon" />
                                                </Link>

                                                // <Link to={`/dashboard/companyconfig/${item.CM_ID

                                                // }`}>
                                                //     <img src={Icon3} alt="Edit" title='Edit' />
                                                // </Link>
                                            )}
                                            {item.CM_Status !== 3 && (
                                                <Link
                                                    to="/dashboard/ccview"
                                                    state={{
                                                        userid: JSON.stringify(item.UM_UserId),
                                                        isEditMode: true,
                                                    }}
                                                    title="View"
                                                    onClick={() => {
                                                        sessionStorage.setItem("CC_ID", JSON.stringify(item.CC_ID));
                                                        navigate(`/dashboard/ccview`);
                                                    }}
                                                >
                                                    <Image src={eye} alt="eye" className="view" />
                                                </Link>
                                            )}

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>
                <ul className="pagination">
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(1)}>First</button>
                    </li>
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
                    </li>
                    {Array.from({ length: Math.ceil(filteredListData.length / itemsPerPage) }, (_, index) => (
                        <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
                            <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
                        </li>
                    ))}
                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
                    </li>
                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(Math.ceil(filteredListData.length / itemsPerPage))}>Last</button>
                    </li>
                </ul>
            </div>
            <Link to={`/dashboard/companyconfig`} type='button' className='back_btn'>
                BACK
            </Link>

            {/* Confirmation Modal */}
            {showConfirmModal && companyToRemove && (
                <div className="popup-overlay">
                    <div className="resetpopup">
                        <h1>:: User Confirmation ::</h1>
                        <h4>Are you sure you want to remove the logo for Company : {companyToRemove.CM_CompanyName} ?</h4>
                        <div className="popup_btn_container">
                            <button className="yes_btn" onClick={confirmLogoRemove}>Yes</button>
                            <button className="no_btn" onClick={() => setShowConfirmModal(false)}>No</button>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

// Add styles for the upload button
const styles = {
    uploadButton: {
        background: 'none',
        border: 'none',
        padding: '5px',
        cursor: 'pointer',
        color: '#295a80',
    }
};

export default CCList;